import {
  salesTeam,
  customerSupport,
  contentCreatorMedia,
  hrRecruitment,
  teamMeetingTaskAutomation,
  marketingProject,
} from "../assets/images/image";

export interface UseCaseItem {
  slug: string;
  title: string;
  subtitle: string;
  /** Optional: URL or require() for card image. Fallback to gradient. */
  image?: string;
  /** Detail page: headline under title */
  headline: string;
  /** Detail page: main description (supports <strong> via dangerouslySetInnerHTML or split) */
  description: string;
  /** Showcase carousel captions */
  showcaseCaptions?: string[];
}

export const USE_CASES: UseCaseItem[] = [
  {
    slug: "sales-team",
    title: "Sales Team",
    subtitle: "Close More Deals, Fewer Tabs",
    image: salesTeam,
    headline: "Close Deals, Not Tabs",
    description:
      "UB's AI <strong>eliminates repetitive tasks</strong>, allowing your sales team to focus on closing deals. It automatically qualifies incoming leads by company size and industry, instantly routes high value prospects to the right sales manager, and even drafts personalized follow up emails <strong>ensuring no opportunity is overlooked.</strong>",
    showcaseCaptions: [
      "Lead Intake & Enrichment",
      "AI Deal Scoring",
      "Real-time Routing to Account Executive",
      "Follow-up Drafts & Deal Forecast",
    ],
  },
  {
    slug: "customer-support",
    title: "Customer Support",
    subtitle: "Swift Outcomes, No Obstacles",
    image: customerSupport,
    headline: "Swift Outcomes, No Obstacles",
    description:
      "AI-powered support workflows resolve tickets faster. Automate triage, suggest responses, and keep every customer conversation on track.",
    showcaseCaptions: [
      "Auto-Triage & Smart Routing",
      "Context-Aware Replies & Fast Escalation",
    ],
  },
  {
    slug: "content-creator-media",
    title: "Content Creator Media",
    subtitle: "Scale Your Creative Output",
    image: contentCreatorMedia,
    headline: "Scale Your Creative Output",
    description:
      "From briefs to publishing, UB helps content teams plan, assign, and deliver more without burning out. AI suggests timelines and resources so creativity stays front and center.",
    showcaseCaptions: [
      "Trend Analysis & Content Angles",
      "Draft Generation & Production Tasks",
      "Edit Workflow & Publish Readiness",
    ],
  },
  {
    slug: "hr-recruitment",
    title: "HR - Recruitment",
    subtitle: "Identify the Right Talent Quickly",
    image: hrRecruitment,
    headline: "Identify the Right Talent Quickly",
    description:
      "Streamline hiring with AI that screens resumes, schedules interviews, and keeps hiring managers aligned. Find the right fit faster and improve candidate experience.",
    showcaseCaptions: [
      "Resume Screening & Interview Scheduling",
      "Onboarding Coordination & Candidate Updates",
    ],
  },
  {
    slug: "team-meeting-task-automation",
    title: "Team Meeting & Task Automation",
    subtitle: "Meetings That Actually Get Work Done",
    image: teamMeetingTaskAutomation,
    headline: "Meetings That Actually Get Work Done",
    description:
      "Turn meeting outcomes into action. UB captures decisions, assigns tasks, and tracks follow-through so nothing falls through the cracks.",
    showcaseCaptions: [
      "Decision Extraction",
      "Actionable Task Creation",
      "Owners Assigned & Deadlines Set",
      "Follow-through Tracking",
    ],
  },
  {
    slug: "marketing-project",
    title: "Marketing Project",
    subtitle: "Execute Campaigns Precisely",
    image: marketingProject,
    headline: "Execute Campaigns Precisely",
    description:
      "Plan, brief, and launch campaigns with clarity. AI helps with timelines, dependencies, and resource allocation so marketing delivers on time and on brand.",
    showcaseCaptions: [
      "Campaign Timeline Orchestration",
      "Performance Reporting & Optimization",
    ],
  },
];

export function getUseCaseBySlug(slug: string): UseCaseItem | undefined {
  return USE_CASES.find((uc) => uc.slug === slug);
}
